export { default, ensureUploadComponent } from "./Config";
